import sizes from './sizes';

export default {
  IconCardOuter: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    width: props => (props.isEditDeckButton ? '50px' : '110px'),
    height: props => (props.isEditDeckButton ? '50px' : '110px'),
    [sizes.down('sm')]: {
      width: props => (props.isEditDeckButton ? '50px' : '50px'),
      height: props => (props.isEditDeckButton ? '50px' : '50px'),
    },

  },
  IconCardInner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: props => (props.isEditDeckButton ? '50px' : '95px'),
    height: props => (props.isEditDeckButton ? '50x' : '95px'),
    color: 'var(--text-primary)',
    borderRadius: '10px',
    transition: 'all .2s',
    [sizes.down('sm')]: {
      width: props => (props.isEditDeckButton ? '50px' : '45px'),
      height: props => (props.isEditDeckButton ? '50px' : '45px'),
    },
    '& i': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all .12s',
      fontSize: props => (props.isEditDeckButton ? '1.5rem' : '36px'),
      margin: '0px 0px 0px 0px',
      height: '60%',
      [sizes.down('sm')]: {
        fontSize: props => (props.isEditDeckButton ? '1.5rem' : '28px'),
      },
    },
    '& p': {
      display: 'flex',
      padding: '0px 0px 0px 0px',
      margin: '0px 0px 0px 0px',
    },
    '&:hover': {
      cursor: 'pointer',
      color: 'var(--button-accept-primary)',
      boxShadow: props => (!props.isEditDeckButton && '0px 2px 5px 1px rgba(0, 0, 0, 0.3)'),
    },
  },
  IconCardInnerSelected: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '95px',
    height: '95px',
    color: 'var(--button-accept-primary)',
    boxShadow: '0px 2px 5px 1px rgba(0, 0, 0, 0.3)',
    borderRadius: '10px',
    transition: 'all .2s',
    [sizes.down('sm')]: {
      width: props => (props.isEditDeckButton ? '50px' : '45px'),
      height: props => (props.isEditDeckButton ? '50px' : '45px'),
    },
    '& i': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all .12s',
      fontSize: '36px',
      margin: '0px 0px 0px 0px',
      height: '60%',
    },
    '& p': {
      display: 'flex',
      padding: '0px 0px 0px 0px',
      margin: '0px 0px 0px 0px',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  IconCardDisplay: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '95px',
    height: '95px',
    color: 'var(--text-primary)',
    borderRadius: '10px',
    transition: 'all .2s',
    '& i': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all .12s',
      fontSize: '36px',
      margin: '0px 0px 0px 0px',
      height: '60%',
    },
    '& p': {
      display: 'flex',
      padding: '0px 0px 0px 0px',
      margin: '0px 0px 0px 0px',
    },
  },
};
